var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "PageHeader",
        { attrs: { line: false } },
        [
          _c("el-input", {
            directives: [
              {
                name: "debounce",
                rawName: "v-debounce",
                value: _vm.onSearch,
                expression: "onSearch",
              },
            ],
            attrs: {
              size: "mini",
              "prefix-icon": "el-icon-search",
              placeholder: "Search",
              clearable: "",
            },
            on: { clear: _vm.onSearch },
            model: {
              value: _vm.searchVal,
              callback: function ($$v) {
                _vm.searchVal = $$v
              },
              expression: "searchVal",
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          ref: "table",
          attrs: { data: _vm.tableData, "element-loading-text": "Loading..." },
          on: { "sort-change": _vm.onSortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "No.",
              width: "115",
              prop: "No",
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Type",
              width: "115",
              prop: "Type",
              sortable: "custom",
              formatter: _vm.formatType,
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Message",
              "min-width": "150",
              prop: "Message",
              sortable: "custom",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.Type === "text"
                      ? [_vm._v(" " + _vm._s(row.Message) + " ")]
                      : row.Type === "link"
                      ? [
                          _c(
                            "el-link",
                            {
                              staticClass: "link",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.goTo(row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(row.Message))]
                          ),
                        ]
                      : row.Type === "image" ||
                        row.Type === "video" ||
                        row.Type === "voice"
                      ? [
                          _c(
                            "el-link",
                            {
                              staticClass: "link",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewMsg(row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(row.Message))]
                          ),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Created On",
              width: "150",
              prop: "CreatedOn",
              sortable: "custom",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrap" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 25, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("ViewMsgDialog", {
        attrs: { visible: _vm.viewMsgDialogVisible, data: _vm.row },
        on: {
          "update:visible": function ($event) {
            _vm.viewMsgDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.row = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }